export default {
  /**
   * @description 判断class名
   * @param {HTMLElement} ele
   * @param {string} cls
   * @returns {boolean}
   */
  class_has: (ele, cls) =>
    !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)')),

  /**
   * @description 添加class名
   * @description Add class to element
   * @param {HTMLElement} ele
   * @param {string} cls
   */
  class_add: (ele, cls) => {
    if (!class_has(ele, cls)) ele.className += ' ' + cls
  },

  /**
   * @description 移除class名
   * @param {HTMLElement} ele
   * @param {string} cls
   */
  class_remove(ele, cls) {
    if (class_has(ele, cls)) {
      const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
      ele.className = ele.className.replace(reg, ' ')
    }
  },

  /**
   * @description 切换class名
   * @param {HTMLElement} ele
   * @param {string} cls
   */
  class_toggle: (ele, cls) => {
    if (!ele || !cls) {
      return
    }
    let classString = ele.className
    const nameIndex = classString.indexOf(cls)
    if (nameIndex === -1) {
      classString += '' + cls
    } else {
      classString =
        classString.substr(0, nameIndex) +
        classString.substr(nameIndex + cls.length)
    }
    ele.className = classString
  },
}
